<template>
    <input
        :id="id"
        ref="input"
        v-model="modelValue"
        :class="['forms__input', $attrs.class, sizeClass, { 'forms__input--disabled': props.disabled }]"
        :placeholder="placeholder"
        :type="props.type"
        :dusk="dusk"
        :autocomplete="autocomplete"
        :required="required"
        :disabled="disabled"
        :min="props.min"
        :max="props.max"
        :tabindex="props.tabindex"
        :step="props.step"
        v-bind="$attrs"
        data-1p-ignore
        @focus="emit('focus', $event)"
        @blur="emit('blur', $event)"
    />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { Ref } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

defineOptions({
    inheritAttrs: false,
});

const modelValue = defineModel({
    type: [String, Number],
});

const emit = defineEmits<{
    (event: 'focus', content: any): void;
    (event: 'blur', content: any): void;
}>();

const props = withDefaults(defineProps<FieldComponent>(), {
    placeholder: undefined,
    value: null,
    size: 'base',
    type: 'number',
    dusk: null,
    autocomplete: 'off',
    id: null,
    required: false,
    disabled: false,
    min: null,
    max: null,
    tabindex: null,
    step: null,
});

const sizeClass: Ref<string> = computed((): string => {
    const sizes = {
        xs: 'forms__input--xs',
        sm: 'forms__input--sm',
        base: 'forms__input--base',
        lg: 'forms__input--lg',
        xl: 'forms__input--xl',
    };

    return sizes[props.size] ?? sizes.base;
});

const input = ref(null as HTMLInputElement | null);

const focus = (): void => {
    if (!props.disabled) {
        input.value?.focus();
    }
};

defineExpose({ focus });

const placeholder = computed((): string => (props.placeholder ? `${props.placeholder}` : ''));
</script>
